import Model from "./base/model";

class userFollowOrder extends Model {
  resourceName() {
    return "user_follow_order";
  }

  fields() {
    return {
      order_id: "",
      user_id: "",

      order: {jsonApi: "hasOne", type: "orders"},
      user: {jsonApi: "hasOne", type: "users"},

    };
  }

}

export default new userFollowOrder();
